import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface Props {
  onDismiss: () => void;
}

export const VersionUpdateModal: React.FC<Props> = ({ onDismiss }) => (
  <Dialog open onOpenChange={onDismiss}>
    <DialogContent className="max-w-[400px]">
      <DialogHeader>
        <DialogTitle>Update available</DialogTitle>
        <DialogDescription>
          A new version of the application is available. Refresh the page to get the latest features and fixes.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button variant="outline" onClick={onDismiss}>
          Later
        </Button>
        <Button variant="default" onClick={() => window.location.reload()}>
          Refresh
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
